<template>
	<div class="wrap">
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党建宣传</el-breadcrumb-item>
				<el-breadcrumb-item>党建要闻</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.query.type=='add'?'新增':'编辑'}}党建要闻</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="contrl_bar">
						<el-button type="primary" size="small"
						@click="$router.go(-1)">返回上级</el-button>
					</div>
					<div class="addTitle">{{$route.query.type=='add'?'新增':'编辑'}}党建要闻</div>
					<div class="addWrap">
						<el-form 
							label-position="right"
							label-width="120px"
							ref="formData" 
							:model="formData" 
							:rules="rules">
							<el-form-item class="form_item" label="标题" prop="title">
								<el-input
									placeholder="请输入标题"
									v-model="formData.title">
								</el-input>
							</el-form-item>
							<el-form-item class="form_item" label="发布时间">
								<el-date-picker
									v-model="formData.pub_time"
									type="date"
									value-format="timestamp"
									placeholder="选择发布时间">
								</el-date-picker>
							</el-form-item>
							<el-form-item class="form_item" label="封面" prop="">
								<el-upload
									style="text-align: left !important;"
									name="file"
									:data="{token:$store.state.user.userinfo.token}"
									:action="$uploadImg"
									:show-file-list="false"
									:on-success="success"
									:before-upload="$limitImg">
									<img v-if="imageUrl" :src="imageUrl" class="fengmian">
									<el-button  type="primary">{{imageUrl == null || imageUrl == ''?'上传封面':'重新上传'}}</el-button>
									<div class="tishi">支持格式：jpg、png，图片不得大于2M&nbsp;&nbsp;&nbsp;版本更新如图片丢失请重新上传提交</div>
								</el-upload>
							</el-form-item>
							<el-form-item class="form_item" label="来源" prop="source">
								<el-input
									placeholder="请输入来源"
									v-model="formData.source">
								</el-input>
							</el-form-item>
							<el-form-item 
								style="align-items: center !important;"
								class="form_item" label="类型" prop="type">
								<el-radio-group v-model="formData.type" @change="checkData">
									<el-radio label="1">图文</el-radio>
									<el-radio label="2">链接</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item v-if="formData.type == '1'" class="form_item fuwenben" label="内容" 
								:prop="formData.type == '1'?'content':''">
								<quill-editor :options="$VueQuillEditor" ref="myTextEditor" v-model="formData.content" style="height:327px !important;width: 800px;"></quill-editor>
							</el-form-item>
							<el-form-item v-if="formData.type == '2'" class="form_item fuwenben" label="链接"  
								:prop="formData.type == '2'?'url':''">
								<el-input style="width: 500px !important;" placeholder="请输入链接" v-model="formData.url"></el-input>
							</el-form-item>
							<el-form-item style="margin-left: 120px;">
								<el-button type="primary" @click="submit()">发布</el-button>
								<el-button @click="$router.go(-1)">取消</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { djxc } from '@/axios'
	import { Message } from 'element-ui'
	let that;
	export default{
		data(){
			return{
				isUploaded:"上传封面图",
				formData:{
					id:"",
					uid:this.$store.state.user.userinfo.id,
					flag:this.$store.state.user.userinfo.flag,
					pub_time:"",
					pub_user:this.$store.state.user.userinfo.dw,
					title:"",
					sz_img:"",
					source:"",//来源
					content:"",//图文
					url:"",//链接
					type:1//1图文  2 链接
				},
				imageUrl:"",
				rules:{
					// 检测标题是否为空
					title: [
						{ required: true, message: '请输入标题', trigger: 'blur' }
					],
					// 检测是否填写党员姓名是否为空
					name: [
						{ required: true, message: '请输入党员姓名', trigger: 'blur' }
					],
					// 检测文本是否为空
					content: [
						{ required: true, message: '请输入内容', trigger: 'blur' }
					],
					// 检测链接是否为空
					url: [
						{ required: true, message: '请输入链接', trigger: 'blur' }
					]
				}
			}
		},
		methods:{
			// 获取数据
			getdata(){
				djxc.zbNewsUpdateGet({
					id:that.$route.query.id
				}).then(res => {
					if(res.code == 200){
						for(let i in res.data){
							for(let j in that.formData){
								if(i == j){
									that.formData[j] = res.data[i];
								}
							}
						}
						that.imageUrl = res.data.sz_img
					}
				})
			},
			checkData(value){
				// 编辑时检测
				if(that.$route.query.type == 'edit'){
					if(value == '链接'){
						that.formData.content=that.formData.content!=""?that.formData.content:'';
					}else{
						that.formData.url=that.formData.url!=""?that.formData.url:''
					}
				}
			},
			//提交
			submit(){
				that.$refs.formData.validate((valid) => {
					if (valid) {
						if(that.$route.query.type == 'edit'){
							djxc.zbNewsUpdate(that.formData).then(res => {
								if(res.code == 200){
									Message.success("成功")
									that.$router.go(-1)
								}else{
									Message.error(res.msg)
								}
							})
						}else{
							djxc.zbNewsAdd(that.formData).then(res => {
								if(res.code == 200){
									Message.success("成功")
									that.$router.go(-1)
								}else{
									Message.error(res.msg)
								}
							})
						}
					} else {
						return false;
					}
				});
			},
			// 上传封面图成功
			success(res, file) {
				if(res.code == 200){
					that.imageUrl = URL.createObjectURL(file.raw);
					that.isUploaded = "重新上传"
					that.formData.sz_img = res.data.src
			
				}else{
					Message({
						type:"error",
						message:"上传失败，请检查文件或网络连接"
					})
				}
			}
		},
		mounted() {
			if(that.$route.query.type == 'edit'){
				that.getdata();
			}
		},
		created() {
			that = this;
			that.$emit('selectTop',2)
		}
	}
</script>

<style lang="scss">
	.wrap{
		width: 100%;
		position: relative;
		color: $index_color;
		font-size: index_size1;
		.addTitle{
			width: 100%;
			border-bottom: 1px solid #DDE2EE;
			padding-bottom: 15px;
			margin: -40px 0 20px 0;
			font-size: 18px;
			color: #333333;
			font-weight: bold;
			width: 80%;
		}
		.addWrap{
			.el-upload{
				text-align: left !important;
			}
			.form_item{
				width: 100%;
				margin-bottom: 15px;
				display: flex !important;
				align-items: flex-start !important;
				font-size: 14px;
				.el-input{
					width: 220px !important;
				}
				.fengmian{
					display: inline-block;
					vertical-align: bottom;
					height: 150px;
					margin-right: 10px;
					margin-left: 0;
					width: 223px;
				}
				.picture{
					display: inline-block;
					vertical-align: bottom;
					margin-right: 10px;
					margin-left: 0;
					width: 110px;
					height: 150px;
				}
				.tishi{
					font-size: 12px;
					color: rgb(131, 138, 157);
					margin-top: 10px;
				}
			}
			.el-form-item__content{
				margin-left: 0 !important;
			}
			.fuwenben{
				padding-bottom: 110px;
			}
			.submit{
				padding-left: 85px;
			}
			.el-form-item__error{
				position: relative !important;
				margin-left: 20px;
				line-height: 30px;
			}
		}
	}
</style>
